import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

const useTheme = () => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const theme = searchParams.get('theme');

    return {
      pps: theme === 'pps'
    };
  }, [searchParams]);
};

export default useTheme;
